import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const DashboardContainer = styled.div`
  padding: 10rem;
  background-color: #f5f6fa;
  min-height: 100vh;
  text-align:center;

   @media (max-width: 768px) {
    align-items: center; 
    padding: 5rem 8rem;
  }

  @media (max-width: 480px) {
    align-items: center; 
    padding: 5rem 5rem;
  }

    p{
    margin:0;
     color: #91abb3;
    @media (max-width: 768px) {
        font-size: 12px;
    }

    @media (max-width: 480px) {
        font-size: 12px;
    }
}

`;

const Grid = styled.div`
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;

  @media (max-width: 768px) {
   justify-content: center; 
  }

  @media (max-width: 480px) {
    justify-content: center; 
  }
 
`;

const Card = styled.div`
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  padding: 1.5rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  h5{
   color: #385963;
  }
  

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.1);
  }
`;

const Title = styled.h3`
  margin-bottom: 20px;
  font-size: 1.8rem;
  color: #385963;
  text-align:center;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #91abb3;
  margin-top: 0.5rem;
  text-align:center;

 @media (max-width: 768px) {
    font-size: 12px;
  }

  @media (max-width: 480px) {
     font-size: 12px;
  }

`;


const AdminDashboard = () => {
 
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const sections = [
    { path: '/admin/about-pieria', title: t('aboutPieria'), description: t('adminAboutPieriaInfo') },
    { path: '/admin/all-categories-admin', title: t('allCategories'), description: t('adminAllCategoriesDescr') },
    { path: '/admin/users', title: t('registeredUsers'), description: t('adminUsersDesc') },
    { path: '/admin/providers', title: t('providers'), description: t('adminProvidersDesc') },
    { path: '/admin/destinations', title: t('destinations'), description: t('adminDestinationsDesc') },
    { path: '/admin/experiences', title: t('experiences'), description: t('adminExperiencesDesc') },
    { path: '/admin/events', title: t('events'), description: t('adminEventsDesc') },
    { path: '/admin/amenities', title: t('amenities'), description: t('adminAmenitiesDesc') },
    { path: '/admin/requests', title: t('requests'), description: t('adminRequestsDesc') },
   
  ];



  return (
    <DashboardContainer>
        <Title>{i18n.t('adminDashboard')}</Title>
        <p>{i18n.t('adminDashDescr')}</p>
      <Grid>
        {sections.map(({ path, title, description }) => (
          <Card key={path} onClick={() => navigate(path)}>
            <h5>{title}</h5>
            <Description>{description}</Description>
          </Card>
        ))}
      </Grid>
    </DashboardContainer>
  );
};

export default AdminDashboard;
